export default __webpack_public_path__ + "static/media/Hood of the Lector.e55d8b10.jpg";